import { APPLICATION_NAME } from 'constants/settings';
import { studentSchoolTypeOptions } from 'modules/Auth/components/UserProfile/components/UpdateProfile/data';

export default {
  layout: {
    type: 'inline',
  },
  tailLayout: {},
  requiredMark: false,
  submitButtonText: 'Tìm kiếm',
  appName: APPLICATION_NAME,
  formFields: [
    {
      label: 'Loại tài khoản',
      name: 'roleId',
      initialValue: 1,
      hasFeedback: false,
      inputComponent: {
        type: 'Select',
        props: {
          style: { minWidth: 120 },
          options: [
            { label: 'Học sinh', value: 1 },
            { label: 'Giáo viên', value: 2 },
          ],
        },
      },
    },
    {
      label: 'Cấp',
      name: 'schoolTypeId',
      initialValue: 5,
      hasFeedback: false,
      inputComponent: {
        type: 'Select',
        props: {
          style: { minWidth: 120 },
          options: studentSchoolTypeOptions.concat({ label: 'Tất cả', value: 5 }),
        },
      },
    },
    {
      label: 'Email',
      name: 'email',
      initialValue: '',
      hasFeedback: false,
      inputComponent: {
        type: 'Input',
        props: {
          style: {},
        },
      },
    },
    {
      label: 'Điện thoại',
      name: 'phone',
      initialValue: '',
      hasFeedback: false,
      inputComponent: {
        type: 'Input',
        props: {
          style: {},
        },
      },
    },
  ],
};
